import React, { useEffect, useState } from 'react';
import '../../../../../App.css';
import MUIDataTable from 'mui-datatables';
import {makeStyles} from '@material-ui/core/styles';
import {Container, Typography, Select, MenuItem, TextField} from '@material-ui/core';
import SearchBar from '../../../../../components/shared/SearchBar';
import generateStyles from './style';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Payment } from '../payments.model';
import { formatDate, getHeaderForPrint } from '../../../../../common/common.service';
import { deletePayment, getAllPayments } from '../payment.service';
import { Link } from 'react-router-dom';
import Loading from '../../../../../components/shared/Loading';
import { useConfirm } from 'material-ui-confirm';
import jsPDF from 'jspdf';
import { getUser } from '../../../../login/login.service';

const options: any = {
  selectableRows: 'none',
   setRowProps: () => {
    return {
      style: {boxShadow: '0px 3px 5px #00000029', borderRadius: 6}
    };
  }
};

export default function PaymentReceived(props: any): JSX.Element {
  const currentMonth = new Date().getMonth();
  const classes = generateStyles();
  const [ paymentList, setPaymentList ] = useState<any[]>([]);
  const [ rows, setRows ] = useState<any[]>([]);
  const [ filterMonth, setFilterMonth ] = useState<number>(-1);
  const { filterYear} = props;
  const [ searchText, setSearchText ] = useState<string>('');
  const [ loading, setLoading ] = useState<boolean>(false);
  const confirm = useConfirm();
  let mounted = true;


  const handleFilteMonthChange = (e: any) => {
    setFilterMonth(e.target.value);
  }

  useEffect(() => {
    console.log(paymentList);
    
    var year = filterYear
    if(filterMonth>2){
      year = filterYear-1
    }
    const newRows = paymentList.filter((row: any) => (filterMonth === 12 ? true : (new Date(row.date).getMonth() === filterMonth && new Date(row.date).getFullYear() === year)) && (row.companyName.toLowerCase().includes(searchText.toLowerCase().trim())));
    setRows(newRows);
  },[filterMonth, filterYear]);

  const handleItemDelete = (id: string, index: number) => {
    confirm({
      title: 'Heads Up,',
      description: 'Are your sure? Want to delete this Payment record?',
      cancellationText: 'No',
      confirmationText: 'Yes, Delete it!',
      dialogProps: {
        open: true,
        maxWidth: 'xs'
      }
    })
    .then(() => {
      setLoading(true);
      deletePayment(id)
      .then(_ => {
        setLoading(false);
        let newRows = [...rows]
        newRows.splice(index, 1);
        setRows(newRows);
      })
      .catch((err: any) => {
        setLoading(false);
        console.log(err)
      });
    })
    .catch(() => console.log('Cancelled!'))
  }

  const columns: any = [
    {
      name:"sno",
      label: 'S.NO',
      options: {
        sort: false,
        setCellHeaderProps: () => ({ style: { borderBottomLeftRadius: 6, borderTopLeftRadius: 6, display: 'flex', height: '52.8px', justifyContent: 'center', alignItems: 'center' } }),
        setCellProps: () => ({style: {borderBottomLeftRadius: 6, borderTopLeftRadius: 6}}),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          console.log(rows)
          return (
            <div style={{textAlign: 'center', color:"#112b42"}}>{tableMeta.rowIndex + 1}</div>
          );
        }
      }
    },
    {
      name:"companyName",
      label: 'Company Name',
      options: {
        sortThirdClickReset: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <div style={{color:"#112B42"}}>
              { value }
            </div>
          );
        }
      }
    }, 
    {
      name: 'date',
      label:"Date",
      options: {
        sortThirdClickReset: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <div style={{color:"#112B42"}}>
              { value.split('-').reverse().join('-') }
            </div>
          );
        }
      }
    },
    { 
      name: "transactionId",
      label:"Transaction ID",
      options: {
        sortThirdClickReset: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <div style={{color:"#112B42"}}>
              { value }
            </div>
          );
        }
      }
    }, 
    {
      name: "paymentMode",
      label:"Payment Mode",
      options: {
        sortThirdClickReset: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <div style={{color:"#112B42"}}>
              { value }
            </div>
          );
        }
      }
    }, 
    {
      name: "amount",
      label:"Amount",
      options: {
        sortThirdClickReset: true,
        setCellHeaderProps: () => ({className: makeStyles({'rateHeader': {'& > span': {justifyContent: 'flex-end'}}})().rateHeader}),
        customBodyRender: (value: React.ReactNode) => {
          return (
            <div className="txt-al-r" style={{color:"112b42"}}> ₹ {value?.toLocaleString('en-IN')}</div>
          );
        }
      }
    },
    {
      name: 'action',
      label: "Action",
      options: {
        filter: false,
        sort: false,
        empty: true,
        setCellHeaderProps: () => ({ style: { borderBottomRightRadius: 6, borderTopRightRadius: 6, display: 'table-cell', textAlign: 'right', paddingRight: 35 } }),
        setCellProps: () => ({style: {borderBottomRightRadius: 6, borderTopRightRadius: 6}}),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <div className="txt-al-r" style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
              <img onClick={() => preparePDF(value)} src="/img/print.png" alt="print icon"  style={{cursor: 'pointer', width:"20px", marginLeft:"10px"}}/>
              <Link to={`/dashboard/payments/${value}`}><img src="/img/editpencil.png" alt="edit icon" style={{cursor: 'pointer', width:"17px", marginLeft:"13px"}}/></Link>
              {/* <Link to={`/dashboard/payments/${value}`}><VisibilityIcon style={{display: 'flex', alignItems: 'center', cursor: 'pointer', marginLeft:"13px", marginRight:"10px"}} /></Link> */}
              <img src="/img/delete.png" alt="delete icon" onClick={() => handleItemDelete(value, tableMeta.rowIndex)} style={{cursor: 'pointer', width:"13px", marginLeft:"13px", marginRight:"10px"}}/>
            </div>
          );
        }
      }
    },
  ];

  const mapPaymentToRow = (payment: Payment, index: number) => {
    return {
      companyName: payment.customer.companyName,
      date: formatDate(payment.date),
      transactionId: payment.transactionId,
      paymentMode: payment.mode,
      amount: payment.amount,
      action: payment.id
    };
  }

  const fetchAndSetInvoiceList = async () => {
    setLoading(true);
    getAllPayments((payments: Payment[])=> {
      console.log(payments);
      const paymentRows = payments.map(mapPaymentToRow);
      console.log(paymentRows);
      // setRows(paymentRows);
      if(mounted) {
        setPaymentList(paymentRows);
        setFilterMonth(currentMonth);
        setLoading(false);
      }
    });
  }

  // componentDidMount
  useEffect(() => {
    fetchAndSetInvoiceList();
    return () => {
      mounted = false
    }
  }, []);

  const handleSearch = (text: string) => {
    console.log('Search text trigger => ', searchText, rows);
    const payments = paymentList.filter((payment: any) => (filterMonth === 12 ? true : (new Date(payment.date).getMonth() === filterMonth && new Date(payment.date).getFullYear() === filterYear)) && (payment.companyName.toLowerCase().includes(text.toLowerCase().trim())))
    setRows(payments);
    setSearchText(text)
  }

  const billNo = rows.length;
  const amount = rows.reduce((acc: any, curr: any) => acc + curr.amount, 0);

  const preparePDFForPaymentList = () => {
    setLoading(true);
    const user = getUser();
    const tableRows = rows.map((row: any, index: number) => `
    <tr style="font-size: 6px;">
        <td>${index + 1}</td>
        <td>${row.companyName}</td>
        <td>${formatDate(row.date).split('-').reverse().join('-')}</td>
        <td>${row.transactionId}</td>
        <td>${row.paymentMode}</td>
        <td>${row.amount}</td>
    </tr>
    `); 
    const paymentList = `
    <main style="width: 425px; height: 610px;display: flex; flex-direction: column;">


      <hr />

      <div style="height:text-align: center;display: flex; flex-direction: column; justify-content: center; margin-bottom: 20px">
          <h3 style="text-align: center;margin: 0">Payment Summary</h3>
          <h6 style="text-align: center;margin: 0">${filterMonth !== 12 ? `${filterMonth+1}/`: ''}${filterYear}</h6>
      </div>

      ${getHeaderForPrint({user})}

      <div style="margin-top: 20px; display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100% !important; padding: 0 8px">
          <div style="font-size: 6px; width: 90%; margin-bottom: 10px; display: flex; justify-content: space-around">
              <div>
                  <p>Bill No.</p>
                  <p>Rs.${billNo.toLocaleString('en-IN')}</p>
              </div>
              <div>
                  <p>Amount Received</p>
                  <p>Rs.${amount.toLocaleString('en-IN')}</p>
              </div>
          </div>
          <table style="width: 100%">
              <tr style="font-size: 6px;background-color: #f1f1f1;">
                  <td>S.No</td>
                  <td>Customer Name</td>
                  <td>Date</td>
                  <td>Transaction ID</td>
                  <td>Payment Mode</td>
                  <td>Amount</td>
              </tr>

              ${tableRows.join('')}
          </table>
      </div>
  </main>
    `;
    var doc = new jsPDF({
        orientation: 'p',
        unit: 'px',
        format: 'a4'
       });
    doc.html(paymentList, {
        callback: function (doc) {
        // doc.save();
        doc.autoPrint();
        var oHiddFrame = document.createElement("iframe");
        oHiddFrame.style.position = "fixed";
        oHiddFrame.style.visibility = "hidden";
        oHiddFrame.src = doc.output("bloburl").toString();
        document.body.appendChild(oHiddFrame);
        oHiddFrame.onload = () => {
            if(oHiddFrame.contentWindow) {
                setLoading(false);
                oHiddFrame.contentWindow.focus();
            }
        };
        },
        x: 10,
        y: 10
    });
  }

  const preparePDF = (id: string) => {
    setLoading(true);
    const user = getUser();
    const payment = paymentList.find((pay: any) => pay.action === id);
    console.log(payment);
    const paymentPdf = `
        <main style="width: 425px; height: 610px;display: flex; flex-direction: column;">


            <hr />

            <div style="height:text-align: center;display: flex; flex-direction: column; justify-content: center; margin-bottom: 20px">
                <h3 style="text-align: center;margin: 0">Payment</h3>
                <h6 style="text-align: center;margin: 0">${filterMonth+1}/${filterYear}</h6>
            </div>

            ${getHeaderForPrint({user})}

            <div style="margin-top: 20px; width: 100% !important; padding: 0 8px">

                <!-- <table style="width: 40%; border-collapse: collapse">
                  <tr>
                    <td style="border-left: 0.5px solid #000; border-right: 0.25px solid #000; border-top: 0.5px solid #000; font-size: 6px">Customer Name</td>
                    <td style="border-right: 0.5px solid #000; border-top: 0.5px solid #000; font-size: 6px">Hemath DJ</td>
                  </tr>
                  <tr>
                    <td style="border-left: 0.5px solid #000; border-right: 0.25px solid #000; border-top: 0.5px solid #000; font-size: 6px">Amount</td>
                    <td style="border-right: 0.5px solid #000; border-top: 0.5px solid #000; font-size: 6px">Rs.8000</td>
                  </tr>
                  <tr>
                    <td style="border-left: 0.5px solid #000; border-right: 0.25px solid #000; border-top: 0.5px solid #000; font-size: 6px">Payment Date</td>
                    <td style="border-right: 0.5px solid #000; border-top: 0.5px solid #000; font-size: 6px">25-09-2020</td>
                  </tr>
                  <tr>
                    <td style="border-left: 0.5px solid #000; border-right: 0.25px solid #000; border-top: 0.5px solid #000; font-size: 6px">Transaction ID</td>
                    <td style="border-right: 0.5px solid #000; border-top: 0.5px solid #000; font-size: 6px">TID1234</td>
                  </tr>
                  <tr>
                  <td style="border-left: 0.5px solid #000; border-right: 0.25px solid #000; border-top: 0.5px solid #000; border-bottom: 0.5px solid #000; font-size: 6px">Payment Mode</td>
                  <td style="border-right: 0.5px solid #000; border-top: 0.5px solid #000; border-bottom: 0.5px solid #000; font-size: 6px">CASH</td>
                  </tr>
                </table> -->

                <div style="width: 35%; font-size: 6px">
                  <div style="margin-bottom: 5px">
                    <span>Customer Name</span>
                    <div style="background-color: #f4f4f4; padding: 3px">${payment.companyName}</div>
                  </div>
                  <div style="margin-bottom: 5px">
                    <span>Amount Received</span>
                    <div style="background-color: #f4f4f4; padding: 3px">Rs. ${payment.amount}</div>
                  </div>
                  <div style="width: 100%; display: flex;margin-bottom: 5px">
                    <div style="width: 50%">
                      <span>Payment Date</span>
                      <div style="background-color: #f4f4f4; padding: 3px">${payment.date}</div>
                    </div>
                    <div style="width: 50%; margin-left: 3px">
                      <span>Transaction ID</span>
                      <div style="background-color: #f4f4f4; padding: 3px">${payment.transactionId}&nbsp;</div>
                    </div>
                  </div>
                  <div style="margin-bottom: 5px">
                    <span>Payment Mode</span>
                    <div style="background-color: #f4f4f4; padding: 3px">${payment.paymentMode}</div>
                  </div>
                </div>
            </div>
        </main>
    `;
    var doc = new jsPDF({
        orientation: 'p',
        unit: 'px',
        format: 'a4'
       });
    doc.html(paymentPdf, {
        callback: function (doc) {
        // doc.save();
        doc.autoPrint();
        var oHiddFrame = document.createElement("iframe");
        oHiddFrame.style.position = "fixed";
        oHiddFrame.style.visibility = "hidden";
        oHiddFrame.src = doc.output("bloburl").toString();
        document.body.appendChild(oHiddFrame);
        oHiddFrame.onload = () => {
            if(oHiddFrame.contentWindow) {
                setLoading(false);
                oHiddFrame.contentWindow.focus();
            }
        };
        },
        x: 10,
        y: 10
    });
  }


  return (
    <>
      <Container maxWidth="lg">
        <header className={classes.header}>
          <span style={{color:"#112B42"}}>Payment Received</span>
          <span style={{display: 'flex', alignItems: 'center'}}>
            {/* <SearchBar searchText="Search Items..." addBtnLink='/dashboard/payments/new' value={searchText} size="lg" searchFunction={handleSearch}/>
            <Select
              className={classes.drop}
              disableUnderline
              IconComponent={(props) => <ExpandMoreIcon {...props}/>}
              onChange={handleFilteMonthChange}
              value={filterMonth}
            >
                <MenuItem value={-1}>Select month</MenuItem>
                <MenuItem value={0}>January</MenuItem>
                <MenuItem value={1}>February</MenuItem>
                <MenuItem value={2}>March</MenuItem>
                <MenuItem value={3}>April</MenuItem>
                <MenuItem value={4}>May</MenuItem>
                <MenuItem value={5}>June</MenuItem>
                <MenuItem value={6}>July</MenuItem>
                <MenuItem value={7}>August</MenuItem>
                <MenuItem value={8}>September</MenuItem>
                <MenuItem value={9}>October</MenuItem>
                <MenuItem value={10}>November</MenuItem>
                <MenuItem value={11}>December</MenuItem>
                <MenuItem value={12}>All Months</MenuItem>
            </Select>

            <TextField
              style={{color: '#96A9C3 !important', backgroundColor: '#F4F4F6', width: 150, padding: '0 10px', borderRadius: 5, marginRight: 25,}}
              InputProps={{disableUnderline: true}}
              // labelId="demo-simple-select-label"
              // label="Age"
              id="demo-simple-select"
              // onChange={handleChange}
              className={classes.drop}
              select
              SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
              value={filterYear}
              onChange={handleFilterYearChange}
          >
              <MenuItem value={-1}>Select year</MenuItem>
              <MenuItem value={2020}>2020</MenuItem>
              <MenuItem value={2021}>2021</MenuItem>
              <MenuItem value={2022}>2022</MenuItem>
              <MenuItem value={2023}>2023</MenuItem>
              <MenuItem value={2024}>2024</MenuItem>
              <MenuItem value={2025}>2025</MenuItem>
          </TextField> */}
          </span>
        </header>
      </Container>
      <hr style={{height: 1, backgroundColor: '#ced2de', border: 'none'}}></hr>
      <Container maxWidth="lg" className="mt-20" style={{ fontSize:"13px"}}>
        <div className={classes.boxbillamount}>
          <div className={classes.billamount} >
          <Typography style={{ marginRight:'5px', fontSize:"13px", color:"#7F7F7F"}}>Bill No </Typography>
            <Typography style={{fontWeight:'bold', color:'#0079E4'}}> {billNo}</Typography>
          </div>
          <div className={classes.billamount} style={{color:"#7F7F7F"}}>Amount Received
            <Typography style={{fontWeight:'bold', color:'#0079E4', textAlign:'center'}}>₹ {amount.toLocaleString('en-IN')}</Typography>
          </div>
          <SearchBar searchText="Search Items..." styles={{backgroundColor: '#fff', marginLeft: 20}} addBtnLink='/dashboard/payments/new' value={searchText} size="lg" searchFunction={handleSearch}/>
          <div style={{display: 'flex', alignItems: 'center'}}>
          <Select
              className={classes.drop}
              disableUnderline
              IconComponent={(props) => <ExpandMoreIcon {...props}/>}
              onChange={handleFilteMonthChange}
              value={filterMonth}
            >
                <MenuItem value={-1}>Select month</MenuItem>
                <MenuItem value={3}>April</MenuItem>
                <MenuItem value={4}>May</MenuItem>
                <MenuItem value={5}>June</MenuItem>
                <MenuItem value={6}>July</MenuItem>
                <MenuItem value={7}>August</MenuItem>
                <MenuItem value={8}>September</MenuItem>
                <MenuItem value={9}>October</MenuItem>
                <MenuItem value={10}>November</MenuItem>
                <MenuItem value={11}>December</MenuItem>
                <MenuItem value={0}>January</MenuItem>
                <MenuItem value={1}>February</MenuItem>
                <MenuItem value={2}>March</MenuItem>
                <MenuItem value={12}>All Months</MenuItem>
            </Select>

          {/*  <TextField
              style={{color: '#96A9C3 !important', width: 100, padding: '0 10px', borderRadius: 5, marginLeft: 20, marginRight: 25,}}
              InputProps={{disableUnderline: true}}
              // labelId="demo-simple-select-label"
              // label="Age"
              id="demo-simple-select"
              // onChange={handleChange}
              className={classes.drop}
              select
              SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
              value={filterYear}
              onChange={handleFilterYearChange}
          >
              <MenuItem value={-1}>Select year</MenuItem>
              <MenuItem value={2020}>2020</MenuItem>
              <MenuItem value={2021}>2021</MenuItem>
              <MenuItem value={2022}>2022</MenuItem>
              <MenuItem value={2023}>2023</MenuItem>
              <MenuItem value={2024}>2024</MenuItem>
              <MenuItem value={2025}>2025</MenuItem>
          </TextField>*/}
          <span onClick={preparePDFForPaymentList} style={{ display: 'flex', alignItems: 'center', marginLeft: 40}} className={`cursor-pointer`}>
              <img src="/img/pdf1.png" alt="pencil icon" style={{marginRight:"7px", width:"16px", color:"red"}}/>
              Pdf
          </span>
          </div>
        </div>
        <MUIDataTable title={"ACME Employee list"} data={rows} columns={columns} options={options} />
      </Container>
      <Loading loading={loading} text="Loading...."/>
    </>
  );
}
